<app-popup-layout #modal class="d-none d-md-block">
  <div class="modal-container">
    <img
      (click)="modal.close()"
      class="help-screen-close-button ms-auto me-xl-n5"
      src="/assets/svg/model-close-btn.svg"
      alt="close"
      />

    <img src="assets/svg/voucher-success.svg" class="w-3/5" alt="Succesful Voucher Generation" />

    <p class="font-size-14 font-medium text-center mb-4">
      You have successfully claimed <strong> {{ data?.points }} </strong>
      @if (data?.accountType === 'EMPLOYEE_REWARDS') {
        <span> reward </span>
      }
      @if (data?.accountType === 'CHANNEL_INCENTIVE') {
        <span> incentive </span>
      }
      points <br> @if (data?.description) {
      <span> for {{ data?.description }} </span>
      } from {{ data?.companyName }}.
    </p>

    <p class="font-size-14 font-medium text-center mb-4 text-success">
      Updated
      @if (data?.accountType === 'EMPLOYEE_REWARDS') {
        <span> Reward </span>
      }
      @if (data?.accountType === 'CHANNEL_INCENTIVE') {
        <span> Incentive </span>
      }
      Balance : <img src="assets/svg/enkash-rewards-currency.svg" alt="Points" class="h-12 w-6"> {{ data?.accountBalance }}
    </p>

    <p class="font-size-10 font-medium text-center mb-4"> <img src="assets/svg/points.svg" alt="Points" class="h-8 px-2"> 1 Point = <img src="assets/svg/rupee.svg" alt="Rupee" class="w-4"> 1 </p>

    <button mat-flat-button color="primary" class="cards-primary-submit d-block text-center" (click)="redeemPoints(); modal.close()">
      Redeem Now
    </button>

  </div>
</app-popup-layout>


<div class="d-block d-md-none">
  <app-action-sheet-controller [isVisible]="true" [overlay]="false" [noHeader]="false">
    <ng-container *ngTemplateOutlet="successPopup"></ng-container>
  </app-action-sheet-controller>
</div>
<ng-template #successPopup>
  <div class="modal-container">
    <img
      (click)="modal.close()"
      class="help-screen-close-button ms-auto me-xl-n5"
      src="/assets/svg/model-close-btn.svg"
      alt="close"
      />

    <img src="assets/svg/voucher-success.svg" class="w-3/5" alt="Succesful Voucher Generation" />

    <p class="font-size-14 font-medium text-center text-success">
      <strong> Congratulations! </strong>
    </p>

    <p class="font-size-14 font-medium text-center mt-10 mb-5">
      You have successfully claimed <strong> {{ data?.points }} </strong>
      @if (data?.accountType === 'EMPLOYEE_REWARDS') {
        <span> reward </span>
      }
      @if (data?.accountType === 'CHANNEL_INCENTIVE') {
        <span> incentive </span>
      }
      points @if (data?.description) {
      <span> for {{ data?.description }} </span>
      } from {{ data?.companyName }}.
    </p>

    <p class="font-size-14 font-medium text-center mb-5 text-success">
      Updated
      @if (data?.accountType === 'EMPLOYEE_REWARDS') {
        <span> Reward </span>
      }
      @if (data?.accountType === 'CHANNEL_INCENTIVE') {
        <span> Incentive </span>
      }
      Balance : <img src="assets/svg/enkash-rewards-currency.svg" alt="Points" class="h-12 w-6"> {{ data?.accountBalance }}
    </p>

    <p class="font-size-10 font-medium text-center mb-5"> <img src="assets/svg/points.svg" alt="Points" class="h-8 px-2"> 1 Point = <img src="assets/svg/rupee.svg" alt="Rupee" class="w-4"> 1 </p>

    <button mat-flat-button color="primary" class="cards-primary-submit d-block text-center" (click)="redeemPoints(); modal.close()">
      Redeem Now
    </button>

  </div>
</ng-template>